import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Divider, Input, List, Space } from 'antd';
import styles from './home.module.sass';

const CustomSearchFilter = ({
  filters,
  handleEntryFilterSubmit,
  handleEntryFilterReset,
  checkedFilters,
  setCheckedFilters,
  confirm,
  clearFilters,
  setClearInputFilter,
  searchPlaceholderText,
}) => {
  const [filtersToShow, setFiltersToShow] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllIndeterminate, setSelectAllIndeterminate] = useState(false);
  const [entryToSearchBy, setEntryToSearchBy] = useState('');

  useEffect(() => {
    const clearEntryInput = () => setEntryToSearchBy('');
    setClearInputFilter(() => clearEntryInput);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (filters) {
      setFiltersToShow([...filters]);
    }
  }, [filters]);

  useEffect(() => {
    if (!filtersToShow || !filtersToShow.length) {
      return () => {};
    }
    if (selectAll) {
      setCheckedFilters(
        filtersToShow.reduce(
          (prev, curr) => ({ ...prev, [curr.value]: true }),
          {},
        ),
      );
    } else if (!selectAllIndeterminate && !selectAll) {
      setCheckedFilters(
        filtersToShow.reduce(
          (prev, curr) => ({ ...prev, [curr.value]: false }),
          {},
        ),
      );
    }
  }, [selectAll]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!filtersToShow || !filtersToShow.length) {
      return () => {};
    }
    if (!selectAllIndeterminate) {
      setCheckedFilters(
        filtersToShow.reduce(
          (prev, curr) => ({ ...prev, [curr.value]: false }),
          {},
        ),
      );
    }
  }, [selectAllIndeterminate]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!checkedFilters) {
      setSelectAll(false);
      setSelectAllIndeterminate(false);
      return () => {};
    }
    const checkedFeeds = filtersToShow.filter(
      (feed) => checkedFilters[feed.value],
    );
    const numOfUncheckedFeeds = filtersToShow.length - checkedFeeds.length;
    if (
      numOfUncheckedFeeds > 0 &&
      numOfUncheckedFeeds < filtersToShow.length &&
      (selectAll || selectAllIndeterminate)
    ) {
      setSelectAll(false);
      setSelectAllIndeterminate(true);
    }
  }, [checkedFilters]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (filters?.length > 0) {
      const updatedFilters = filters.map((entry) => {
        const updatedEntry = filtersToShow.find((f) => f.value === entry.value);
        if (updatedEntry) return updatedEntry;
        return entry;
      });
      const searchedFilters = updatedFilters.filter((entry) =>
        entry.text.toLowerCase().includes(entryToSearchBy.toLowerCase()),
      );
      if (selectAll && !selectAllIndeterminate) {
        const notChecked = searchedFilters.some((e) => !checkedFilters[e]);
        if (notChecked) {
          setSelectAll(false);
          setSelectAllIndeterminate(true);
        }
      }
      setFiltersToShow(searchedFilters);
    }
  }, [entryToSearchBy]); // eslint-disable-line react-hooks/exhaustive-deps

  const checkBoxColor = {
    color: '#b1c4d0',
  };
  const checkBoxStyle = {
    display: 'block',
    padding: '5px 5px 5px 0',
    marginLeft: 0,
    ...checkBoxColor,
  };

  const handleSearchFilter = (e) => {
    setEntryToSearchBy(e.target.value);
  };

  const handleCheckBoxClick = (idx) => {
    if (!filtersToShow || !filtersToShow[idx]) return;
    let newEntry = {};
    if (!checkedFilters) {
      newEntry = {
        [filtersToShow[idx].value]: true,
      };
    } else {
      newEntry = {
        ...checkedFilters,
        [filtersToShow[idx].value]: !checkedFilters[filtersToShow[idx].value],
      };
    }
    setCheckedFilters(newEntry);
  };

  const handleSelectAll = (e) => {
    if (selectAllIndeterminate) {
      setSelectAll(false);
      setSelectAllIndeterminate(false);
    } else {
      setSelectAll(!selectAll);
    }
  };

  const handleFilterSubmit = () => {
    let entryToFilterBy;

    if (!checkedFilters) {
      entryToFilterBy = [];
    } else {
      entryToFilterBy = filters
        .filter((f) => checkedFilters[f.value])
        .map((f) => f.value);
    }
    if (entryToFilterBy.length === 0) {
      handleEntryFilterSubmit(null);
    } else {
      handleEntryFilterSubmit(entryToFilterBy);
    }
    confirm();
  };

  const handleFilterReset = () => {
    setEntryToSearchBy('');
    handleEntryFilterReset();
    clearFilters();
  };

  return (
    <div className={styles.customSearchFilter}>
      <div style={{ padding: '10px 10px 5px 10px' }}>
        <Input
          value={entryToSearchBy}
          placeholder={searchPlaceholderText}
          onChange={handleSearchFilter}
        />
        <Checkbox
          indeterminate={selectAllIndeterminate}
          checked={selectAll}
          style={checkBoxStyle}
          onClick={handleSelectAll}
        >
          Select all
        </Checkbox>
      </div>

      <Divider style={{ margin: 0, backgroundColor: '#fff' }} plain />
      <div style={{ padding: '5px 0px 10px 10px' }}>
        <List
          style={{ minWidth: '200px', height: '200px', overflow: 'auto' }}
          dataSource={filtersToShow}
          renderItem={(feed, idx) => (
            <List.Item className={styles.listItem}>
              <Checkbox
                key={feed.value}
                checked={checkedFilters?.[feed.value]}
                onClick={() => handleCheckBoxClick(idx)}
                style={checkBoxColor}
              >
                {feed.text}
              </Checkbox>
            </List.Item>
          )}
        />
      </div>
      <Divider style={{ margin: 0, backgroundColor: '#fff' }} plain />
      {/* <Space style={{ padding: '10px' }}> */}
      <div style={{ padding: 8, minHeight: '40px' }}>
        <Button
          type="primary"
          onClick={handleFilterSubmit}
          size="small"
          style={{ float: 'right' }}
        >
          Apply
        </Button>
        <Button
          onClick={handleFilterReset}
          size="small"
          style={{ marginRight: '8px', border: 'none', float: 'right' }}
        >
          Clear
        </Button>
      </div>
      {/* </Space> */}
    </div>
  );
};

export default CustomSearchFilter;
